export enum PaymentProcessingError {
	None = 0,

	UserNotFound = 1,

	UnallowedAccountType = 2,

	AccountVerificationRequired = 3,

	UserAccountSuspended = 4,

	AdminAccountLock = 5,

	UserPermanentLock = 6,

	UserTemporaryLock = 7,

	NoFundsToWithdraw = 8,

	UnknownError = 9,

	BonusInfoError = 10,

	ProviderTemporarilyUnavailable = 11,

	DepositLimitReached = 12,

	DepositLimitExceeded = 13,

	DepositAccountVerificationRequired = 14,

	DepositLimitRequired = 15,

	AccountNotVerified = 16,

	AccountReVerificationRequired = 17,

	AccountPartiallyVerified = 18,

	DepositLimit_VerificationRequired = 19,

	DepositLimitReached_VerificationRequired = 20,

	DepositLimitExceeded_VerificationRequired = 21,

	DepositLimitReached_ReverificationRequired = 22,

	DepositLimit_ReverificationRequired = 23,

	DepositLimitExceeded_ReverificationRequired = 24,

	DepositLimit_VerificationIncomplete = 25,

	DepositLimitReached_VerificationIncomplete = 26,

	DepositLimitExceeded_VerificationIncomplete = 27,

	RegulatoryDepositLimitReached = 28,

	RegulatoryDepositLimitExceeded = 29,

	AccountVerificationGracePeriodExpired = 30,

	DailyDepositLimitReached = 31,

	DailyDepositLimitExceeded = 32,

	WeeklyDepositLimitReached = 33,

	WeeklyDepositLimitExceeded = 34,

	MonthlyDepositLimitReached = 35,

	MonthlyDepositLimitExceeded = 36,

	MonthlyShopDepositLimitReached = 37,

	MonthlyShopDepositLimitExceeded = 38,

	MonthlyDepositLimitRequired = 39,

	YearlyCasinoDepositLimitReached = 40,

	YearlyCasinoDepositLimitExceeded = 41,

	AmountNotValid = 100,

	AmountInsufficient = 101,

	PaymentMethodNotValid = 102,

	PaymentMethodNotFound = 103,

	PaymentReferenceNotValid = 104,

	PaymentMethodDisabled = 105,

	MinAmountLimit = 106,

	MaxAmountLimit = 107,

	NoAvailablePaymentMethods = 108,

	NoActiveWithdrawalReferences = 109,

	PaymentModeNotValid = 110,

	PaymentSummaryNotValid = 111,

	PaymentMethodChangeUnallowed = 112,

	OfflinePaymentMinAmount = 113,

	OfflinePaymentMaxAmount = 114,

	MaxPendingPaymentsExceeded = 115,

	MaxUnsettledPaymentsExceeded = 116,

	PaymentMethodCountryRestriction = 117,

	MaxWithdrawalAmountPerMethod = 118,

	WithdrawalMethodChangeRequired = 119,

	NotificationNullOrEmpty = 200,

	ParameterNotValidOrMissing = 201,

	ParameterValueMismatch = 202,

	CurrencyNotValid = 203,

	ChecksumMismatch = 204,

	DepositUpdateMismatch = 205,

	WithdrawalUpdateMismatch = 206,

	MerchantIdMissingOrInvalid = 207,

	MerchantSiteIdMissingOrInvalid = 208,

	MerchantIdMismatch = 209,

	MerchantSiteIdMismatch = 210,

	DepositStatusMissingOrInvalid = 211,

	DepositTransactionIdMissingOrInvalid = 212,

	AmountMissingOrInvalid = 213,

	PaymentMethodMissingOrInvalid = 214,

	UserIdMissingOrInvalid = 215,

	ChecksumMissing = 216,

	WDRequestIdMissingOrInvalid = 217,

	WdRequestStateUndefined = 218,

	WdRequestStatusUndefined = 219,

	WdOrderStatusUndefined = 220,

	WDOrderIdMissingOrInvalid = 221,

	WdNotificationTypeUndefined = 222,

	DepositFailedExternal = 223,

	DepositCanceledExternal = 224,

	NonExistingWithdrawalProcessed = 225,

	BonusRolloverIncomplete = 226,

	TransactionIdMissing = 227,

	DatabaseUnavailable = 301,

	LockDeadlock = 302,

	DepositAlreadyProcessed = 303,

	DepositDuplicate = 304,

	WithdrawalAlreadyProcessed = 305,

	WithdrawalDuplicate = 306,

	WithdrawalNotChanged = 307,

	CurrencyNotFound = 308,

	TransactionTypeNotFound = 309,

	UnknownDatabaseError = 310,

	PaymentTransactionNotFound = 311,

	GracePeriodConfirmationError = 325,

	UserDataConfirmationError = 77,
}
